export const breakpoints = {
  small: '36em',
  medium: '48em',
  large: '62em',
  xLarge: '75em',
  xxLarge: '95em',
};
